import api from '@/api/axiosConfig.js';

const BASE_PATH = '/api/flota';

function getResponseData(response, fallback = []) {
  if (!response?.data?.ok) {
    const errorMessage = response?.data?.error || 'Respuesta inválida del servidor.';
    throw new Error(errorMessage);
  }
  return response.data.data ?? fallback;
}

function buildServiceError(error, fallbackMessage) {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.details ||
    error?.message ||
    fallbackMessage;
  const nextError = new Error(message);
  nextError.status = error?.response?.status || null;
  nextError.field = error?.response?.data?.field || null;
  nextError.code = error?.response?.data?.code || error?.code || null;
  nextError.details = error?.response?.data?.details || null;
  nextError.errors = error?.response?.data?.errors || null;
  nextError.payload = error?.response?.data || null;
  return nextError;
}

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.append(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

export async function fetchVehiculos(filters = {}) {
  const response = await api.get(`${BASE_PATH}${buildQuery(filters)}`);
  return getResponseData(response, []);
}

export async function fetchVehiculo(id) {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return getResponseData(response, null);
}

export async function createVehiculo(payload) {
  try {
    const response = await api.post(BASE_PATH, payload);
    return getResponseData(response, null);
  } catch (error) {
    throw buildServiceError(error, 'No se pudo crear el vehículo.');
  }
}

export async function updateVehiculo(id, payload) {
  try {
    const response = await api.put(`${BASE_PATH}/${id}`, payload);
    return getResponseData(response, null);
  } catch (error) {
    throw buildServiceError(error, 'No se pudo actualizar el vehículo.');
  }
}

export async function deactivateVehiculo(id) {
  try {
    const response = await api.delete(`${BASE_PATH}/${id}`);
    return getResponseData(response, null);
  } catch (error) {
    throw buildServiceError(error, 'No se pudo desactivar el vehículo.');
  }
}
